(function () {
  const widgetSelector = '.Avada-SubscriptionWidget-Block';
  const optionSelector = '.Avada-ModernSelectionBox';
  const script = document.getElementById('YflSubscriptionClarityScript');
  let planQuantities = {};
  let variantInventory = {};
  let purchaseData = null;
  const pricing = window.YflPurchaseModel;
  try { purchaseData = JSON.parse(document.getElementById('YflPurchaseData')?.textContent || 'null'); }
  catch (error) { console.warn('Unable to read Shopify purchase allocations.', error); }

  try {
    planQuantities = JSON.parse(script?.dataset.planQuantities || '{}');
  } catch (error) {
    console.warn('Unable to read the NOVOS bulk subscription quantities.', error);
  }

  try {
    variantInventory = JSON.parse(script?.dataset.variantInventory || '{}');
  } catch (error) {
    console.warn('Unable to read the NOVOS subscription inventory.', error);
  }

  const widgetLabels = {
    heading: script?.dataset.widgetHeading || '',
    oneTime: script?.dataset.widgetOneTime || '',
    save: script?.dataset.widgetSave || '',
    each: script?.dataset.widgetEach || '',
    bulkStockNotice: script?.dataset.bulkStockNotice || '',
    bulkUnavailableBadge: script?.dataset.bulkUnavailableBadge || '',
  };

  function normaliseLabel(value) {
    return value.replace(/\s+/g, ' ').trim().toLocaleLowerCase('en');
  }

  const planLabels = new Map(
    [
      ['Annually (12 Boxes Upfront)', script?.dataset.planAnnualBoxes],
      ['Semi-Annually (6 boxes Upfront)', script?.dataset.planSixBoxes],
      ['Monthly (1 Box Upfront)', script?.dataset.planMonthlyBox],
      ['Annually (12 Pouches Upfront)', script?.dataset.planAnnualPouches],
      ['Semi-Annually (6 Pouches Upfront)', script?.dataset.planSixPouches],
      ['Monthly (1 Pouch Upfront)', script?.dataset.planMonthlyPouch],
      ['Prepay every 12 months, receive every 1 month', script?.dataset.planPrepaidTwelveMonths],
      ['Prepay every 6 months, receive every 1 month', script?.dataset.planPrepaidSixMonths],
      ['Every 1 month', script?.dataset.planEveryMonth],
    ]
      .filter(([, translatedLabel]) => translatedLabel)
      .map(([sourceLabel, translatedLabel]) => [normaliseLabel(sourceLabel), translatedLabel])
  );

  function setTextContent(element, value) {
    if (!element || !value || element.textContent?.trim() === value) return;
    element.textContent = value;
  }

  function localisePriceUnit(container) {
    if (!widgetLabels.each) return;

    for (const node of container.childNodes) {
      if (node.nodeType !== 3 || !node.nodeValue?.includes('/each')) continue;
      const localisedValue = node.nodeValue.replaceAll('/each', widgetLabels.each);
      if (localisedValue !== node.nodeValue) node.nodeValue = localisedValue;
    }
  }

  function getOptionPlan(option) {
    if (option.getAttribute('avada-data-value') === 'one-time-purchase') return null;
    if (!purchaseData) return undefined;
    if (option.dataset.yflPlanId) return purchaseData.plans.find(plan => plan.id === option.dataset.yflPlanId);
    const label = normaliseLabel(option.querySelector('.Avada-ModernSelectionBox-Label')?.textContent || '');
    const appId = option.getAttribute('avada-data-value');
    const matches = purchaseData.plans.filter(plan => (plan.appId && plan.appId === appId) || normaliseLabel(plan.name) === label);
    // Map only an unambiguous real Shopify plan. Never infer a discount from its label.
    if (matches.length !== 1) return undefined;
    option.dataset.yflPlanId = matches[0].id;
    return matches[0];
  }

  function getCurrentForm() {
    return document.querySelector('.main-product-form form[action$="/cart/add"]') || document.querySelector('form[action$="/cart/add"]');
  }

  function getOptionQuote(option) {
    if (!pricing || !purchaseData) return null;
    const plan = getOptionPlan(option);
    if (plan === undefined) return null;
    const form = getCurrentForm();
    const variantId = form?.querySelector('input[name="id"]')?.value;
    const input = form && getQuantityInput(form);
    const quantity = input?.dataset.yflBulkQuantity ? 1 : input?.value;
    return pricing.quote(purchaseData, variantId, plan?.id, quantity);
  }

  function renderOptionQuote(option) {
    const quote = getOptionQuote(option);
    let summary = option.querySelector('.yfl-purchase-option-summary');
    if (!quote) { summary?.remove(); return; }
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'yfl-purchase-option-summary';
      for (const className of ['quantity', 'total', 'renewal', 'shipping']) {
        const row = document.createElement('p');
        row.className = 'yfl-purchase-option-' + className;
        summary.append(row);
      }
      const link = document.createElement('a');
      link.href = purchaseData.shippingPolicyUrl;
      link.textContent = purchaseData.labels.shippingPolicy;
      link.addEventListener('click', event => event.stopPropagation());
      summary.append(link);
      option.append(summary);
    }
    const labels = purchaseData.labels;
    setTextContent(summary.querySelector('.yfl-purchase-option-quantity'), pricing.fill(labels.quantity, { quantity: quote.quantity, price: pricing.money(quote.price, purchaseData) }));
    setTextContent(summary.querySelector('.yfl-purchase-option-total'), pricing.fill(labels.total, { total: pricing.money(quote.total, purchaseData) }));
    setTextContent(summary.querySelector('.yfl-purchase-option-renewal'), quote.months ? pricing.fill(labels.renewal, { months: quote.months }) : labels.oneTime);
    setTextContent(summary.querySelector('.yfl-purchase-option-shipping'), pricing.shipping(purchaseData, quote.total, quote.freeShipping));
    option.dataset.yflQuoteReady = 'true';
  }

  function arrangeOptions(widget) {
    if (!purchaseData) return;
    const oneTime = widget.querySelector(optionSelector + '[avada-data-value="one-time-purchase"]');
    const container = oneTime?.parentElement;
    if (!container) return;
    const options = Array.from(widget.querySelectorAll(optionSelector));
    const bulk = options.filter(option => getOptionPlan(option)?.quantity > 1).sort((a,b) => getOptionPlan(a).quantity - getOptionPlan(b).quantity);
    const monthly = options.filter(option => getOptionPlan(option)?.quantity === 1);
    let details = container.querySelector('details.yfl-bulk-options');
    if (bulk.length && !details) {
      details = document.createElement('details');
      details.className = 'yfl-bulk-options';
      const summary = document.createElement('summary');
      summary.textContent = purchaseData.labels.bulk;
      details.append(summary);
      container.append(details);
    }
    if (container.firstElementChild !== oneTime) container.prepend(oneTime);
    let previous = oneTime;
    monthly.forEach(option => {
      if (previous.nextElementSibling !== option) previous.insertAdjacentElement('afterend', option);
      previous = option;
    });
    bulk.forEach(option => { if (option.parentElement !== details) details.append(option); });
    if (details && bulk.some(option => option.classList.contains('selected'))) details.open = true;
    widget.setAttribute('role', 'radiogroup');
    widget.setAttribute('aria-label', widgetLabels.heading);
    options.forEach(option => {
      option.setAttribute('role', 'radio');
      option.setAttribute('aria-checked', option.classList.contains('selected') ? 'true' : 'false');
      option.tabIndex = option.dataset.yflSubscriptionUnavailable === 'true' ? -1 : 0;
    });
  }

  function updateDailyCost(widget) {
    const output = document.querySelector('[data-yfl-daily-cost]');
    if (!output || !purchaseData || !pricing) return;
    const option = widget?.querySelector(optionSelector + '.selected');
    const quote = option && getOptionQuote(option);
    const variantId = getCurrentForm()?.querySelector('input[name="id"]')?.value;
    const price = quote?.price ?? purchaseData.variants[variantId]?.price;
    if (Number.isFinite(price)) setTextContent(output, pricing.fill(purchaseData.labels.daily, { price: pricing.money(price / 30, purchaseData) }));
  }

  function updateStickyCommitment(widget) {
    if (!purchaseData || !pricing) return;
    const option = widget.querySelector(optionSelector + '.selected');
    const quote = option && getOptionQuote(option);
    if (!quote) return;
    const total = pricing.money(quote.total, purchaseData);
    document.querySelectorAll('sticky-atc').forEach(sticky => {
      setTextContent(sticky.querySelector('[id^="sticky-atc-price-"]'), total + ' •');
      setTextContent(sticky.querySelector('[id^="sticky-atc-separate-price-"]'), pricing.fill(purchaseData.labels.total, { total }));
      const container = sticky.querySelector('.sticky-atc__button');
      if (!container) return;
      let summary = container.querySelector('.yfl-sticky-purchase-summary');
      if (!summary) {
        summary = document.createElement('p');
        summary.className = 'yfl-sticky-purchase-summary';
        container.prepend(summary);
      }
      summary.hidden = !quote.months && quote.quantity === 1;
      const quantity = pricing.fill(purchaseData.labels.quantity, { quantity: quote.quantity, price: pricing.money(quote.price, purchaseData) });
      const renewal = quote.months ? pricing.fill(purchaseData.labels.renewal, { months: quote.months }) : purchaseData.labels.oneTime;
      setTextContent(summary, quantity + ' · ' + renewal);
    });
  }

  function localiseWidget(widget) {
    widget.querySelectorAll(optionSelector).forEach(getOptionPlan);
    setTextContent(widget.querySelector('.Avada-Subscription__Label'), widgetLabels.heading);
    setTextContent(
      widget.querySelector(`${optionSelector}[avada-data-value="one-time-purchase"] .Avada-ModernSelectionBox-Label`),
      widgetLabels.oneTime
    );

    widget.querySelectorAll('.Avada-Block4__LabelText').forEach((label) => {
      const translatedLabel = planLabels.get(normaliseLabel(label.textContent || ''));
      setTextContent(label, translatedLabel);
    });
    widget.querySelectorAll('.Avada-Badge__SaveText').forEach((label) => setTextContent(label, widgetLabels.save));
    widget.querySelectorAll('.Avada-Price__Sale, .Avada-Price__Regular').forEach(localisePriceUnit);
  }

  function getOptionQuantity(option) {
    return getOptionPlan(option)?.quantity || 0;
  }

  function getSelectedVariantInventory() {
    const variantInput = getCurrentForm()?.querySelector('input[name="id"]');
    if (!variantInput?.value) return null;
    return variantInventory[variantInput.value] || null;
  }

  function hasEnoughInventory(quantity) {
    const inventory = getSelectedVariantInventory();
    if (!inventory || !inventory.managed || inventory.policy === 'continue') return true;
    return Number(inventory.quantity) >= quantity;
  }

  function setBulkStockNotice(widget, visible) {
    const selector = widget.querySelector('.Avada-Subscription__Selector');
    if (!selector || !widgetLabels.bulkStockNotice) return;

    let notice = widget.querySelector('.yfl-subscription-stock-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'yfl-subscription-stock-notice';
      notice.setAttribute('role', 'status');
      selector.insertAdjacentElement('afterend', notice);
    }

    setTextContent(notice, widgetLabels.bulkStockNotice);
    notice.hidden = !visible;
  }

  function updatePlanAvailability(widget) {
    let hasUnavailableBulkPlan = false;

    widget.querySelectorAll(optionSelector).forEach((option) => {
      const quantity = getOptionQuantity(option);
      const plan = getOptionPlan(option);
      const quote = getOptionQuote(option);
      const unavailable = (quantity > 0 && !hasEnoughInventory(quote?.quantity || quantity)) || (plan && !quote);
      option.classList.toggle('yfl-subscription-option-unavailable', unavailable);
      option.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      option.dataset.yflSubscriptionUnavailable = unavailable ? 'true' : 'false';

      let badge = option.querySelector('.yfl-subscription-unavailable-badge');
      if (unavailable && widgetLabels.bulkUnavailableBadge) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'yfl-subscription-unavailable-badge';
          option.append(badge);
        }
        setTextContent(badge, widgetLabels.bulkUnavailableBadge);
      } else {
        badge?.remove();
      }

      if (unavailable) hasUnavailableBulkPlan = true;
    });

    const selectedUnavailable = widget.querySelector(
      `${optionSelector}.selected[data-yfl-subscription-unavailable="true"]`
    );
    if (selectedUnavailable) {
      widget.querySelector(`${optionSelector}[avada-data-value="one-time-purchase"]`)?.click();
    }

    setBulkStockNotice(widget, hasUnavailableBulkPlan);
  }

  function updateCommitmentNote(widget) {
    synchronisePlanQuantities();
    arrangeOptions(widget);
    widget.querySelectorAll(optionSelector).forEach(renderOptionQuote);
    updateDailyCost(widget);
    updateStickyCommitment(widget);
  }

  function getSellingPlanInput(form) {
    return form.querySelector('input[name="selling_plan"]');
  }

  function getQuantityInput(form) {
    const quantityField = form.elements.namedItem('quantity');
    return quantityField instanceof HTMLInputElement ? quantityField : null;
  }

  function getRequiredPlanQuantity(form) {
    const sellingPlanId = getSellingPlanInput(form)?.value?.trim();
    const quantity = Number.parseInt(planQuantities[sellingPlanId], 10);
    return quantity === 6 || quantity === 12 ? quantity : 0;
  }

  function rememberQuantityState(input) {
    if (input.dataset.yflQuantityStateSaved === 'true') return;

    input.dataset.yflQuantityStateSaved = 'true';
    input.dataset.yflOriginalMin = input.getAttribute('min') || '';
    input.dataset.yflOriginalMax = input.getAttribute('max') || '';
    input.dataset.yflOriginalReadonly = input.readOnly ? 'true' : 'false';
  }

  function setQuantityControlsLocked(input, locked) {
    const container = input.closest('quantity-input, .quantity');
    if (!container) return;

    container.classList.toggle('yfl-subscription-quantity-locked', locked);
    container.querySelectorAll('.quantity__button').forEach((button) => {
      button.disabled = locked;
      button.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });
  }

  function lockPlanQuantity(form, quantity) {
    const input = getQuantityInput(form);
    if (!input) return;

    rememberQuantityState(input);
    const nextValue = String(quantity);
    const valueChanged = input.value !== nextValue;

    input.value = nextValue;
    input.min = nextValue;
    input.max = nextValue;
    input.readOnly = true;
    input.setAttribute('aria-readonly', 'true');
    input.dataset.yflBulkQuantity = nextValue;
    setQuantityControlsLocked(input, true);

    if (valueChanged) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function unlockPlanQuantity(form) {
    const input = getQuantityInput(form);
    if (!input || !input.dataset.yflBulkQuantity) return;

    const originalMin = input.dataset.yflOriginalMin;
    const originalMax = input.dataset.yflOriginalMax;
    const originalReadonly = input.dataset.yflOriginalReadonly === 'true';

    input.value = originalMin || '1';
    originalMin ? input.setAttribute('min', originalMin) : input.removeAttribute('min');
    originalMax ? input.setAttribute('max', originalMax) : input.removeAttribute('max');
    input.readOnly = originalReadonly;
    input.setAttribute('aria-readonly', originalReadonly ? 'true' : 'false');
    delete input.dataset.yflBulkQuantity;
    setQuantityControlsLocked(input, false);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyPlanQuantity(form) {
    const quantity = getRequiredPlanQuantity(form);
    if (quantity) {
      lockPlanQuantity(form, quantity);
    } else {
      unlockPlanQuantity(form);
    }
    return quantity;
  }

  function initialiseProductForm(form) {
    if (form.dataset.yflSubscriptionQuantityGuard === 'true') return;

    form.dataset.yflSubscriptionQuantityGuard = 'true';
    form.addEventListener('formdata', (event) => {
      const quantity = applyPlanQuantity(form);
      if (quantity) event.formData.set('quantity', String(quantity));
    });
  }

  function synchronisePlanQuantities() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
      initialiseProductForm(form);
      applyPlanQuantity(form);
    });
  }

  function initialiseWidget(widget) {
    if (widget.dataset.yflSubscriptionClarity === 'true') return;

    const oneTime = widget.querySelector(`${optionSelector}[avada-data-value="one-time-purchase"]`);
    if (!oneTime) return;

    // Joy places the longest prepaid commitment first. Keep the underlying
    // selling plans unchanged while presenting the lower-commitment choice
    // first in this theme.
    oneTime.parentElement?.prepend(oneTime);

    widget.dataset.yflSubscriptionClarity = 'true';
    document.querySelectorAll('[data-yfl-purchase-fallback]').forEach(element => { element.hidden = true; });
    widget.addEventListener('keydown', event => {
      if (!(event.target instanceof Element)) return;
      const option = event.target.closest(optionSelector);
      if (!option || event.target.closest('a')) return;
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); option.click(); }
      if (!['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      const options = Array.from(widget.querySelectorAll(optionSelector)).filter(item => item.dataset.yflSubscriptionUnavailable !== 'true' && (!item.closest('details') || item.closest('details').open));
      const index = options.indexOf(option);
      if (index < 0 || !options.length) return;
      const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
      const next = options[(index + direction + options.length) % options.length];
      event.preventDefault(); next.focus(); next.click();
    });
    widget.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const option = event.target.closest(optionSelector);
      if (!option) return;
      if (option.dataset.yflSubscriptionUnavailable === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        setBulkStockNotice(widget, true);
        return;
      }
      window.setTimeout(() => {
        updateCommitmentNote(widget);
        updatePlanAvailability(widget);
      }, 50);
    }, true);

    const selectionObserver = new MutationObserver(() => updateCommitmentNote(widget));
    selectionObserver.observe(widget, { attributes: true, attributeFilter: ['class'], subtree: true });

    const hasExplicitSellingPlan = new URLSearchParams(window.location.search).has('selling_plan');
    if (!hasExplicitSellingPlan && !oneTime.classList.contains('selected')) oneTime.click();
    updateCommitmentNote(widget);
  }

  function initialiseWidgets() {
    document.querySelectorAll(widgetSelector).forEach((widget) => {
      localiseWidget(widget);
      updatePlanAvailability(widget);
      initialiseWidget(widget);
      updateCommitmentNote(widget);
    });
    synchronisePlanQuantities();
  }

  document.addEventListener(
    'submit',
    (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      if (!event.target.matches('form[action$="/cart/add"]')) return;
      applyPlanQuantity(event.target);
    },
    true
  );

  initialiseWidgets();
  document.addEventListener('DOMContentLoaded', initialiseWidgets, { once: true });
  document.addEventListener('variant-change', initialiseWidgets);
  document.addEventListener('input', event => {
    if (event.target instanceof HTMLInputElement && event.target.name === 'quantity') window.setTimeout(initialiseWidgets, 0);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') subscribe(PUB_SUB_EVENTS.variantChange, initialiseWidgets);
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && ['id', 'quantity', 'selling_plan'].includes(event.target.name)) {
      window.setTimeout(initialiseWidgets, 0);
    }
  });

  const widgetObserver = new MutationObserver(initialiseWidgets);
  widgetObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
